import React from 'react';
import '../../styles/AdminModal.css';
import { bulkDeleteBlogPosts } from '../../services/AdminBlogService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

const BlogPostsBulkDeleteModal = ({ isOpen, onClose, onSuccess, selectedPosts }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleDelete = async () => {
    if (!selectedPosts || selectedPosts.length === 0) {
      setError('No posts selected for deletion.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await bulkDeleteBlogPosts(selectedPosts);
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error bulk deleting posts:', error);
      setError('Failed to delete posts. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Posts</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>

        {error && (
          <div className="error-message">{error}</div>
        )}

        <div className="admin__modal-body">
          <p>
            Are you sure you want to delete <strong>{selectedPosts?.length || 0}</strong> selected post(s)?
          </p>
          <p>This action cannot be undone.</p>
        </div>

        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="button" onClick={handleDelete} disabled={loading}>
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogPostsBulkDeleteModal; 